gsap.registerPlugin(ScrollTrigger);
// Put your application javascript here

$(function() {
  // This will select everything with the class smoothScroll
  // This should prevent problems with carousel, scrollspy, etc...
  $('.smoothScroll').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 500); // The number here represents the speed of the scroll in milliseconds
        return false;
      }
    }
  });
});

// ---------------------------------------------------------------------------
// Set correct 100vh safari
// ---------------------------------------------------------------------------
// const appHeight = () => {
//   const doc = document.documentElement
//   doc.style.setProperty('--app-height', `${window.innerHeight}px`)
// }

// window.addEventListener('resize', appHeight)
// appHeight()


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ---------------------------------------------------------------------------
// Add class on scroll
// ---------------------------------------------------------------------------

window.onscroll = function() {scrollFunction()};
$(document).ready(scrollFunction());
function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    let topBarH = $('.announcement-bar').outerHeight();
    document.getElementsByTagName('header')[0].classList.add('scrolled');
    document.getElementsByTagName('header')[0].style.transform = "translateY(-" + topBarH + "px)";
    $('meta[name="theme-color"]').attr('content', '#D53E23');
  } else {
    document.getElementsByTagName('header')[0].classList.remove('scrolled');
    document.getElementsByTagName('header')[0].style.transform = "translateY(0)";
    $('meta[name="theme-color"]').attr('content', '#B7341C');
  }
}

// ---------------------------------------------------------------------------
// Announcement bar slider
// ---------------------------------------------------------------------------

$(document).ready(function() {
  const announcementSwiper = new Swiper('.announcement-bar.swiper', {
    effect: "fade",
    loop: true,
    slidesPerView: 1,
    autoHeight: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
  });
});


// ---------------------------------------------------------------------------
// Footer toggle
// ---------------------------------------------------------------------------

$(document).ready(function() {
  const footerMenu = $('.footer-block__menu h2');
  footerMenu.on( "click", function() {
    if(window.matchMedia('(max-width: 1080px)').matches){
      $(this).next().fadeToggle('fast');
      $(this).toggleClass('open');
    }
  });
});


// ---------------------------------------------------------------------------
// Mostra country selector alla prima visita
// ---------------------------------------------------------------------------
// $(document).ready(function(){
//   const announcementOpacity = document.getElementById('opacity');
//   const announcement = document.getElementById('countryModal');
//   const announcementClose = document.getElementById('close-countryModal');
//   let queryString = window.location.search;
//   let urlParams = new URLSearchParams(queryString);
//   if (urlParams.has('redirected')) sessionStorage.setItem('firstViewSession', true);
//   if(announcement){
//     if (!(window.location.href.indexOf("/account") > -1)) {
//       $(document).on('scroll',  function(){
//         if(sessionStorage && !sessionStorage.getItem('firstViewSession')){
//           if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
//             //announcementOpacity.classList.add('active');
//             announcement.classList.remove('hidden');
//             sessionStorage.setItem('firstViewSession', true);
//           }
//         }
//       })
//       announcementOpacity.addEventListener('click', () =>{
//         //announcementOpacity.classList.remove('active');
//         announcement.classList.add('hidden');
//       })
  
//       // announcementClose.addEventListener('click', () =>{
//       //   announcementOpacity.classList.remove('active');
//       //   announcement.classList.add('hidden');
//       //   document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
//       // })
//     }
//   }
// })
